export default function TypingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 flex items-center gap-1">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <span className="text-sm text-gray-400 ml-2">Thinking...</span>
      </div>
    </div>
  )
}
